
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.185 8.446L1.11.14A.692.692 0 000 .693v16.615a.693.693 0 001.108.553l11.076-8.307a.692.692 0 000-1.108zM17.308 0h-1.385a.693.693 0 00-.692.692v16.616c0 .382.31.692.692.692h1.385c.382 0 .692-.31.692-.692V.692A.693.693 0 0017.308 0z"}})])
          )
        }
      }
    